import { render } from "./PendingProductStock.vue?vue&type=template&id=24aae0a0&scoped=true"
import script from "./PendingProductStock.vue?vue&type=script&lang=js"
export * from "./PendingProductStock.vue?vue&type=script&lang=js"

import "./PendingProductStock.vue?vue&type=style&index=0&id=24aae0a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24aae0a0"]])

export default __exports__